/* ###########################################################################
// Scroll lock
//
// Freezes the page behind a full-height overlay (the mobile nav panel), so
// scrolling inside the panel doesn't chain through to the document beneath.
// Only ever engaged below the nav's breakpoint, where scrollbars are overlaid
// and hiding them causes no layout shift.
//######################################################################### */

export const disableScroll = () => {
    document.documentElement.style.overflow = 'hidden'
}

export const enableScroll = () => {
    document.documentElement.style.overflow = ''
}
